import type { HTMLAttributes } from 'react';
import { cx } from '../cx';

type Size = 'md' | 'lg' | 'xl';

export function MachineRaroBrand({ size = 'md', className, ...rest }: { size?: Size } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-brand', size !== 'md' && `rr-brand--${size}`, className)} {...rest}>
      <span className="rr-brand__machine">machine.</span>
      <span className="rr-brand__raro">raro</span>
      <span className="rr-brand__tm">™</span>
    </span>
  );
}

/** modo.raro™ — da mesma família de machine.raro™: o cliente entende que é um serviço da RARO, não um software avulso. */
export function ModoRaroBrand({ size = 'md', className, ...rest }: { size?: Size } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-brand', size !== 'md' && `rr-brand--${size}`, className)} {...rest}>
      <span className="rr-brand__machine">modo.</span>
      <span className="rr-brand__raro">raro</span>
      <span className="rr-brand__tm">™</span>
    </span>
  );
}

/** ritmo.raro™ — a operação da conta, da mesma família. */
export function RitmoRaroBrand({ size = 'md', className, ...rest }: { size?: Size } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-brand', size !== 'md' && `rr-brand--${size}`, className)} {...rest}>
      <span className="rr-brand__machine">ritmo.</span>
      <span className="rr-brand__raro">raro</span>
      <span className="rr-brand__tm">™</span>
    </span>
  );
}

export function RaroBrand({ size = 'md', className, ...rest }: { size?: Size } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-brand rr-brand--raro-only', size !== 'md' && `rr-brand--${size}`, className)} {...rest}>
      <span className="rr-brand__raro">RARO</span>
      <span className="rr-brand__tm">™</span>
    </span>
  );
}

/** machine.wall™ — "wall" em amarelo, como no painel de referência. */
export function MachineWallBrand({ size = 'md', className, ...rest }: { size?: Size } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx('rr-brand', size !== 'md' && `rr-brand--${size}`, className)} {...rest}>
      <span className="rr-brand__machine">machine.</span>
      <span className="rr-brand__raro rr-brand__accent">wall</span>
      <span className="rr-brand__tm">™</span>
    </span>
  );
}
